import React, { useLayoutEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';
import content from './content.json';
import './style.scss';

const assets = Object.fromEntries(content.assets.map(({ file }) => {
  const asset = require(`./assets/${file}`);
  return [file, asset.default || asset];
}));

function BenefitNotice() {
  return content.notice.map((part, index) => part.strong
    ? <strong key={index}>{part.text}</strong>
    : <React.Fragment key={index}>{part.text}</React.Fragment>);
}

export default function SLHBenefits() {
  const pageRef = useRef(null);
  const scrollRef = useRef(null);
  const imageViewportRef = useRef(null);
  const [detail, setDetail] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [showTop, setShowTop] = useState(false);

  useLayoutEffect(() => {
    // Keep the site's mobile layout inside the shared H5 scroll container.
    const container = pageRef.current.closest('.container');
    scrollRef.current = container || document.scrollingElement || document.documentElement;
    if (container) container.classList.add('slh-benefits-container');
    const scrollTarget = container || window;
    const onScroll = () => setShowTop(scrollRef.current.scrollTop > 400);
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      scrollTarget.removeEventListener('scroll', onScroll);
      if (container) container.classList.remove('slh-benefits-container');
    };
  }, []);

  const openDetails = (nextDetail) => {
    setZoom(1);
    setDetail(nextDetail);
  };

  const returnToTop = () => {
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (scrollRef.current.scrollTo) {
      scrollRef.current.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    } else {
      scrollRef.current.scrollTop = 0;
    }
  };

  return (
    <main  ref={pageRef} lang="zh-CN">
      {/*<section className="slh-benefits__intro" aria-labelledby="slh-intro-title">
        <h1 id="slh-intro-title">{content.introduction.title}</h1>
        <p>{content.introduction.text}</p>
      </section>*/}

       <h1 className="hotel-member-title">
        <img className="hotel-member-logo slh-logo" src="https://staticfile.badazhou.com/20260922/eb6fb4406db97bd7712637b75b2f187e.png" alt="SLH CLUB"  />
        <span>SLH Club-会员礼遇</span>
      </h1>

     <div className="slh-benefits">

      {content.tiers.map((tier) => (
        <section className="slh-benefits__tier" key={tier.id} aria-labelledby={`slh-${tier.id}-title`}>
          <div className="slh-benefits__copy">
            <h2 id={`slh-${tier.id}-title`}>{tier.title}</h2>
            <p>{tier.intro}</p>
            <button
              type="button"
              className="slh-benefits__image-button"
              aria-label={`查看 ${tier.name} 权益详情`}
              title={`查看 ${tier.name} 权益详情`}
              onClick={() => openDetails({ title: `${tier.name} 会员礼遇`, image: tier.poster, items: tier.benefits, description: tier.description })}
            >
              <img src={assets[tier.poster]} alt={`${tier.name}：${tier.benefits.join('、')}`} style={{ width: tier.posterWidth, height: tier.posterHeight }} width="1080" height={tier.id === 'club-1' ? 1603 : 964} />
            </button>
            <p>{tier.description}</p>
          </div>
        </section>
      ))}

      <section className="slh-benefits__notice" aria-label="会员礼遇适用条件">
        <BenefitNotice />
      </section>

      <section className="slh-benefits__qualification mt-60 c-link pb-60" aria-label={content.qualificationTitle}>
        <button
          type="button"
          className="slh-benefits__image-button"
          aria-label="查看 SLH Club 会员资格详情"
          title="查看 SLH Club 会员资格详情"
          onClick={() => openDetails({ title: content.qualificationTitle, image: content.qualification, items: content.qualificationTiers })}
        >
          <img src={assets[content.qualification]} alt={`${content.qualificationTitle}：${content.qualificationTiers.join('；')}`} width="999" height="517" />
        </button>
      </section>

      {showTop && (
        <button type="button" className="slh-benefits__back-top" aria-label="返回顶部" title="返回顶部" onClick={returnToTop}>
          <ArrowUpOutlined aria-hidden="true" />
        </button>
      )}

      <Modal
        title={detail?.title}
        open={Boolean(detail)}
        onCancel={() => setDetail(null)}
        footer={null}
        centered
        destroyOnClose
        width={720}
        className="slh-benefits-dialog"
      >
        {detail && (
          <div className="slh-benefits-dialog__body">
            
            <div className="slh-benefits-dialog__image-viewport" ref={imageViewportRef} role="region" aria-label="权益原图" tabIndex={0}>
              <img src={assets[detail.image]} alt={detail.title} style={{ width: `${zoom * 100}%` }} />
            </div>
            <ul className="slh-benefits-dialog__items">{detail.items.map((item) => <li key={item}>{item}</li>)}</ul>
            {detail.description && <p>{detail.description}</p>}
            <p className="slh-benefits-dialog__notice"><BenefitNotice /></p>
          </div>
        )}
      </Modal>
      </div>
    </main>
  );
}
